import styled from 'styled-components';
import { rem } from 'polished';

const StyledWidgetLogout = styled.div`
  width: auto;

  .title {
    color: ${props => props.theme.colors.light};
    font-family: ${props => props.theme.fonts.book};
    font-size: ${rem('17px')};
    text-transform: uppercase;
    margin-top: ${rem('5px')};
    margin-bottom: ${rem('30px')};
    line-height: ${rem('20px')};
    display: flex;
    align-items: center;
  }

  .icon-title {
    width: ${rem('17px')};
    fill: ${props => props.theme.colors.light};
    margin-right: ${rem('7px')};
  }
  .box-logout {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${rem('140px')};
  }
  .text {
    color: ${props => props.theme.colors.light};
    margin-bottom: 18px;
  }
`;

export { StyledWidgetLogout };
